import styles from './NotFound.module.css';

/** Catch-all for unknown routes — a real 404 view instead of a silent redirect. */
export function NotFound() {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1 className={styles.title}>This link wandered off.</h1>
        <p className={styles.subtitle}>
          The page moved, expired, or never existed. Your saved bookmarks are
          safe where you left them.
        </p>
        <div className={styles.actions}>
          {/* Plain <a>s: /app re-enters through the auth guard and /docs/ is a
              static page outside the SPA router. */}
          <a href="/app" className={styles.ctaPrimary}>Back to your bookmarks</a>
          <a href="/docs/" className={styles.cta}>Browse the docs</a>
        </div>
      </div>
    </div>
  );
}
